import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRightArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={5}
    height={8}
    fill="none"
    viewBox="0 0 5 8"
    {...props}
  >
    <path
      fill="#999"
      fillRule="evenodd"
      d="M.193 1.413 2.78 4 .193 6.587a.664.664 0 1 0 .94.94l3.06-3.06c.26-.26.26-.68 0-.94L1.133.467a.664.664 0 0 0-.94 0 .68.68 0 0 0 0 .946"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgRightArrow;
